<template>
  <div
    class="frisbuy-text-sticker"
    :style="{
      ...getStickerStylesForText(sticker),
      'max-width': `${sticker.width}%`,
    }"
  >
    <span class="frisbuy-text-sticker__text">
      {{ sticker.text }}
    </span>

    <div
      class="frisbuy-text-sticker__background"
      :style="{
        ...getStickerStylesForText(sticker),
        opacity: backgroundStyles.opacity,
      }"
    >
      <span
        :style="{
          'background-color': backgroundStyles.backgroundColor,
        }"
      >
        {{ sticker.text }}
      </span>

      <svg
        style="visibility: hidden; position: absolute; opacity: 0.1"
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="goo">
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="3"
              result="blur"
            ></feGaussianBlur>
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            ></feColorMatrix>
            <feComposite
              in="SourceGraphic"
              in2="goo"
              operator="atop"
            ></feComposite>
          </filter>
        </defs>
      </svg>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-text-sticker {
  pointer-events: none;
  font-synthesis: none;

  .frisbuy-text-sticker__text {
    z-index: 2;
  }

  .frisbuy-text-sticker__text,
  .frisbuy-text-sticker__background > span {
    position: relative;
    vertical-align: baseline;

    overflow-wrap: break-word;
    border-radius: calc(var(--frisbuy-interaction-width) * 4 * 1px);
    padding: calc(var(--frisbuy-interaction-width) * 0.1 * 1rem)
      calc(var(--frisbuy-interaction-width) * 0.3 * 1rem);

    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
  }

  .frisbuy-text-sticker__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: url(#goo);

    z-index: 1;

    & > span {
      color: transparent;
    }
  }
}
</style>

<script>
export default {
  props: {
    sticker: {
      type: Object,
      require: true,

      backgroundStyles: {
        opacity: 0,
        backgroundColor: "unset",
      },
    },
  },

  data() {
    return {};
  },

  created() {
    this.addFontLinkToHead();

    this.backgroundStyles = this.getBackgroundStyles(
      this.sticker.backgroundColor
    );
  },

  methods: {
    addFontLinkToHead() {
      const styleLoaderContainer = document.createElement("link");
      styleLoaderContainer.setAttribute("rel", "stylesheet");
      styleLoaderContainer.setAttribute(
        "href",
        `https://fonts.googleapis.com/css2?family=${this.sticker.fontName.replaceAll(
          " ",
          "+"
        )}&display=swap`
      );

      let hasEqualNode = false;

      // 'link' nodes append to end of head
      // for optimization loop starts from last node to first
      for (let i = document.head.childNodes.length - 1; i > 0; i--) {
        const node = document.head.childNodes[i];

        if (node.isEqualNode(styleLoaderContainer)) {
          hasEqualNode = true;
          break;
        }
      }

      if (!hasEqualNode) {
        document.head.appendChild(styleLoaderContainer);
      }
    },

    getStickerStylesForText(sticker) {
      return {
        // "background-color": sticker.backgroundColor,
        color: sticker.color,
        "font-family": sticker.fontName,
        "font-size": `calc(var(--frisbuy-interaction-width) * ${sticker.fontSize} * 1px)`,
        "font-style": sticker.fontStyle,
        "font-weight": sticker.fontStyle,
        "text-decoration": sticker.fontStyle,
      };
    },

    getBackgroundStyles(backgroundColor) {
      let format = undefined;

      const formats = {
        hex: "hex",
        rgba: "rgba",
      };

      if (backgroundColor[0] === "#") {
        format = formats.hex;
      } else if (backgroundColor.slice(0, 4) === "rgba") {
        format = formats.rgba;
      }

      if (format === formats.hex) {
        const opacityFromHexBackgroundColor = backgroundColor.slice(-2);
        const HEX = 16;
        const opacityDecimal = parseInt(opacityFromHexBackgroundColor, HEX);

        const HEX_IN_DECIMAL_TWO_BYTES = 255;
        const opacityProportion = opacityDecimal / HEX_IN_DECIMAL_TWO_BYTES;

        const backgroundTemplate = "#000000";
        const backgroundColorInHexWithoutOpacity = backgroundColor.slice(
          0,
          backgroundTemplate.length
        );

        return {
          opacity: opacityProportion,
          backgroundColor: backgroundColorInHexWithoutOpacity,
        };
      }

      if (format === formats.rgba) {
        const backgroundColorDividedProps =
          backgroundColor.indexOf("rgba") != -1
            ? backgroundColor.split("(")[1].split(")")[0].split(",")
            : "";

        const opacity = backgroundColorDividedProps[3];

        const backgroundColorInHexWithoutOpacity = `rgb(${backgroundColorDividedProps[0]}, ${backgroundColorDividedProps[1]}, ${backgroundColorDividedProps[2]})`;

        return {
          opacity,
          backgroundColor: backgroundColorInHexWithoutOpacity,
        };
      }

      return {
        opacity: 1,
        backgroundColor: this.sticker.backgroundColor,
      };
    },
  },
};
</script>
